<nav class="switcher" aria-label="Map layers">
  <button *ngIf="isHeatMember" type="button" class="thumb" [class.active]="selected === heat.key"
    [attr.aria-label]="heat.label" [attr.aria-pressed]="selected === heat.key" [title]="heat.label" (click)="pick(heat)">
    <img [src]="heat.icon" alt="" />
  </button>
  <hr *ngIf="isHeatMember" class="rule" />

  <button *ngFor="let t of fields" type="button" class="thumb" [class.active]="selected === t.key"
    [attr.aria-label]="t.label" [attr.aria-pressed]="selected === t.key" [title]="t.label" (click)="pick(t)">
    <img [src]="t.icon" alt="" />
  </button>

  <hr class="rule" />

  <button *ngFor="let t of pins" type="button" class="thumb" [class.active]="selected === t.key"
    [attr.aria-label]="t.label" [attr.aria-pressed]="selected === t.key" [title]="t.label" (click)="pick(t)">
    <img [src]="t.icon" alt="" />
  </button>

  <button type="button" class="clear" aria-label="Turn off layer" title="Turn off layer" (click)="clear()">
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
      stroke-linecap="round" aria-hidden="true">
      <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  </button>
</nav>
